import { format } from 'date-fns';
import getDateFormats from './getDateFormats';

// Function that returns the current date
export var currentDate = function currentDate() {
  return new Date();
};

// Function that returns true if dueDate is some time next year or later,
// and false if dueDate is in the current year or earlier.
var isFutureYear = function isFutureYear(current, dueDate) {
  var currentYear = current.getFullYear();
  var dueDateYear = dueDate.getFullYear();
  return currentYear < dueDateYear;
};
/**
 * Function that returns proper date format based on expiration date
 * @param dueDate
 * @param bookType
 */
var getDueDate = function getDueDate(dueDate) {
  var futureYear = isFutureYear(currentDate(), dueDate);
  // Adding years if expiration date is in a future year
  // returning only month and day if exp date is in current year
  return futureYear ?
  // example: Feb 22 2021
  format(dueDate, getDateFormats(dueDate).MONTH_DAY_YEAR) :
  // example: Feb 22
  format(dueDate, getDateFormats(dueDate).MONTH_DAY);
};
export default getDueDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/getDueDate.js
// module id = 2847
// module chunks = 11